import request from '@/util/request';
import qs from 'qs';

export const getPage = (params, options) =>
request.get('/api/v4ward/fee-tax-type/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/fee-tax-type/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/fee-tax-type/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/fee-tax-type/save', params, options)

export const update = (params, options) =>
request.post('/api/v4ward/fee-tax-type/update', params, options)

export const getList = (params, options) =>
  request.get('/api/v4ward/fee-tax-type/list', Object.assign({}, options, { params }));

